import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import parallax from './directives/parallax'

import * as VueGoogleMaps from 'vue2-google-maps'
import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'
import gsap from 'vendors/gsap'

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import 'vendors/moment-fr'
import 'utils/filters'

Vue.config.productionTip = false

// Google map
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCVZWJKIz7JXp9mPCSWem6f0-hXtOi2iEE'
  }
})

// Meta data
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

if ( isProd ) {

    Sentry.init({
      dsn: 'https://f1826e7d1ea740dfbbb7566c7f6fdeb0@sentry.io/2039343',
      integrations: [new Integrations.Vue({Vue, attachProps: true})],
    })

}

// Analytics
const isProd = process.env.NODE_ENV === 'production'
Vue.use(VueAnalytics, {
  id: 'UA-152856197-1',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})

const fixIdScrolling = {
  watch: {
    $route (to, from) {
      const currentRoute = this.$router.currentRoute
      const idToScrollTo = currentRoute.hash
      this.$nextTick(() => {
        if (idToScrollTo && document.querySelector(idToScrollTo)) {
          document.querySelector(idToScrollTo).scrollIntoView()
        }
      })
    }
  }
}

new Vue({
  mixins: [fixIdScrolling],
  router,
  store,
  render: h => h(App)
}).$mount('#app')
